// @core/api/endpoints/workflow/create_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateTemplateRequest,
  PipelineTemplateResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Create pipeline template
 * Creates a reusable pipeline template from a pipeline schema. Templates can be shared publicly or within the platform.
 */
export async function CreateTemplate(
  data: CreateTemplateRequest,
  options?: RequestOptions
): Promise<PipelineTemplateResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/workflows/templates`;
  const requestOptions = options;
  return client.post<PipelineTemplateResponse>(requestPath, data, requestOptions);
}
